<ckeditor
        *ngIf="!isMobile"
        #newsFeedEditor
        [(ngModel)]="newsFeed.htmlContent"
        [config]="ckeditorConfig"
        [readonly]="false"
        debounce="500">
    <ckbutton
            [name]="'image'"
            [command]="'openImageExplorer'"
            (click)="openImageExplorer()"
            [label]="'Open image explorer'"
            [toolbar]="'insert,1'">
    </ckbutton>
</ckeditor>
<ckeditor
    *ngIf="isMobile"
    #newsFeedEditor
    [(ngModel)]="newsFeed.htmlContent"
    [config]="ckeditorConfigMobile"
    [readonly]="false"
    debounce="500">
    <ckbutton
            [name]="'image'"
            [command]="'openImageExplorer'"
            (click)="openImageExplorer()"
            [label]="'Open image explorer'"
            [toolbar]="'insert,1'">
    </ckbutton>
</ckeditor>
<div class="row d-flex justify-content-end mt-4 mr-0">
    <div class="d-flex align-items-center">
        <button
                [disabled]="eventService?.selectedEvent?.isPastEvent"
                class="btn btn-primary mr-2" (click)="save()">Save</button>
    </div>
</div>
